<template>
  <div class="border">
    <div class="header capitalize-all">{{ title }}</div>
    <div class="data-container" v-for="row in data" :key="row.currency">
      <div class="row-data row">
        <div class="row">
          <div class="date-container row">
            <b-icon-circle-fill class="icon-white"></b-icon-circle-fill>
            <b-icon-circle-fill class="icon"></b-icon-circle-fill>
          </div>
          <div class="moneda">
            {{ row.currency }}
          </div>
          <div class="sumatorio">
            <div class="total">{{ data[0].total }}</div>
            <div class="row total-desglosado">
              <div class="billetes">
                <span class="icono-billete"><icon-billetes></icon-billetes></span
                ><span class="total-billete">{{ row.banknote }}</span>
              </div>
              <div><span class="vertical-line"></span></div>
              <div class="monedas">
                <span class="icono-monedas"><icon-monedas></icon-monedas></span
                ><span class="total-monedas">{{ row.coin }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="horizontal-line" v-if="row !== data[data.length - 1]"></div>
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";
import IconBilletes from "@/components/common/icon/IconBilletes.vue";
import IconMonedas from "@/components/common/icon/IconMonedas.vue";

@Component({
  components: { IconMonedas, IconBilletes },
})
export default class SaldosPorDivisa extends Vue {
  @Prop({ required: false, default: "SALDOS ACTUALES POR DIVISA" })
  title!: string;

  @Prop({
    required: false,
    default: () => [
      {
        currency: "ARS",
        coin: "1.834.397,38",
        banknote: "1.834.397,38",
        total: "2.348.598,45",
      },
      {
        currency: "USD",
        coin: "1.834.397,38",
        banknote: "1.834.397,38",
        total: "2.348.598,45",
      },
      {
        currency: "EUR",
        coin: "1.834.397,38",
        banknote: "1.834.397,38",
        total: "2.348.598,45",
      },
    ],
  })
  data:
    | [
        {
          currency: string;
          coin: string;
          banknote: string;
          total: string;
        }
      ]
    | undefined;
}
</script>

<style lang="scss" scoped>
.border {
  margin-left: 2rem;
  margin-bottom: 2rem;
  border-radius: 6px;
  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.16);
  background-color: #ffffff;
  padding: 0.5rem 0.5rem 0.5rem 1.5rem;
  min-width: 357px;
}

.header {
  margin: 0 55px 25px 0;
  font-family: Roboto, Arial, Helvetica, sans-serif;
  font-size: 14px;
  font-weight: bold;
  color: #9b9b9b;
  padding-top: 0.5rem;
}

.capitalize-all {
  text-transform: uppercase;
}

.date {
  font-family: Roboto, Arial, Helvetica, sans-serif;
  font-size: 12px;
  font-weight: bold;
  color: var(--amarillo-prosegur);
  padding-left: 0.5rem;
}

.data-header {
  font-family: Roboto, Arial, Helvetica, sans-serif;
  font-size: 12px;
  color: #9b9b9b;
}

.data-body {
  width: 130px;
  font-family: Roboto, Arial, Helvetica, sans-serif;
  font-size: 12px;
  color: #4a4a4a;
}

.row-data {
  position: relative;
  padding-bottom: 1rem;
}

.date-container {
  padding-left: 3rem;
  margin-right: 1rem;
  padding-top: 0.1rem;
}

.vertical-line {
  border-left: solid 1px #e8e8e8;
  padding-right: 0.5rem;
}
.horizontal-line {
  border-top: solid 1px #e8e8e8;
  padding-right: 1rem;
  width: 90%;
  padding-bottom: 1rem;
}
.data-container {
  padding-bottom: 1rem;
}

.hour {
  width: 54px;
  font-size: 12px;
  font-weight: bold;
  padding-left: 0.5rem;
  color: #979797;
}
.icon {
  width: 14px;
  color: var(--amarillo-prosegur);
  z-index: 2;
}

.icon-white {
  width: 11px;
  color: white;
  z-index: 3;
  position: absolute;
  padding-left: 3px;
}
.moneda {
  width: 35px;
  height: 21px;
  font-family: Roboto, Arial, Helvetica, sans-serif;
  font-size: 18px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #4a4a4a;
}
.total {
  width: 116px;
  height: 24px;
  font-family: Roboto, Arial, Helvetica, sans-serif;
  font-size: 20px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #4a4a4a;
}
.total-billete {
  width: 68px;
  height: 14px;
  margin: 6px 10px 19px 7px;
  font-family: Roboto, Arial, Helvetica, sans-serif;
  font-size: 12px;
  font-weight: 300;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #808080;
}
.total-monedas {
  width: 68px;
  height: 14px;
  margin: 6px 10px 19px 7px;
  font-family: Roboto, Arial, Helvetica, sans-serif;
  font-size: 12px;
  font-weight: 300;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #808080;
}
.sumatorio {
  padding-left: 1rem;
}
.total-desglosado {
  padding-left: 1rem;
}
</style>
